document.addEventListener('DOMContentLoaded', function () {

    if (document.querySelector('.read-more') && document.querySelector('.hero-text')) {

        const read_more = document.querySelector('.read-more');
        const hero_text = document.querySelector('.hero-text');
        const collapsedHeight = 90; // same as your CSS collapsed max-height in px

        // Start collapsed
        hero_text.style.maxHeight = collapsedHeight + 'px';

        read_more.addEventListener('click', function () {

            if (hero_text.classList.contains('grow')) {
                // CLOSE: collapse to collapsedHeight
                hero_text.style.maxHeight = collapsedHeight + 'px';
                hero_text.classList.remove('grow');
                read_more.textContent = ajax_object.readMore;
            } else {
                // OPEN: expand to scrollHeight
                hero_text.style.maxHeight = hero_text.scrollHeight + 'px';
                hero_text.classList.add('grow');
                read_more.textContent = ajax_object.readLess;
            }

        });
    }

    document.querySelectorAll('.faq-card').forEach(card => {
        const header = card.querySelector('.faq-card__header');
        const content = card.querySelector('.faq-card__content');

        header.addEventListener('click', () => {
            const isOpen = header.classList.contains('is-open');

            // Close all
            document.querySelectorAll('.faq-card__header').forEach(h => h.classList.remove('is-open'));
            document.querySelectorAll('.faq-card__content').forEach(c => {
                c.classList.remove('is-active');
                c.style.maxHeight = null;
            });

            if (!isOpen) {
                header.classList.add('is-open');
                content.classList.add('is-active');
                content.style.maxHeight = content.scrollHeight + "px";
            }
        });
    });

    const menu = document.querySelector('.h2-anchor-menu');
    const scrollSpeed = 126;
    let scrollingLeft, scrollingRight;

    const startScroll = (direction) => {
        stopScroll();
        const step = () => {
            if (direction === 'left') menu.scrollLeft -= scrollSpeed;
            if (direction === 'right') menu.scrollLeft += scrollSpeed;
            if (scrollingLeft || scrollingRight) {
                requestAnimationFrame(step);
            }
        };
        if (direction === 'left') scrollingLeft = true;
        if (direction === 'right') scrollingRight = true;
        requestAnimationFrame(step);
    };

    const stopScroll = () => {
        scrollingLeft = false;
        scrollingRight = false;
    };

    const leftBtn = document.querySelector('.scroll-btn.left');
    const rightBtn = document.querySelector('.scroll-btn.right');

    leftBtn.addEventListener('mousedown', () => startScroll('left'));
    rightBtn.addEventListener('mousedown', () => startScroll('right'));
    leftBtn.addEventListener('mouseup', stopScroll);
    rightBtn.addEventListener('mouseup', stopScroll);
    leftBtn.addEventListener('mouseleave', stopScroll);
    rightBtn.addEventListener('mouseleave', stopScroll);

});